export const NO_CONTACT_FOUND = "NO_CONTACT_FOUND";
export const GET_CONTACT_DETAILS = "GET_CONTACT_DETAILS";
export const SHOW_CREATE_TICKET = "SHOW_CREATE_TICKET";
export const SHOW_ADD_CONTACT = "SHOW_ADD_CONTACT";
